import React, { useState, useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import {
  Col,
  Row,
  Table,
  Pagination,
  PaginationItem,
  PaginationLink,
  ButtonDropdown,
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
  Label,
  Badge,
} from "reactstrap";
import Widget from "../../components/Widget/Widget.js";
import { format } from 'date-fns';

// import BootstrapTable from "react-bootstrap-table-next";
// import paginationFactory from 'react-bootstrap-table2-paginator';
// import MUIDataTable from "mui-datatables";
import moreIcon from "../../assets/tables/moreIcon.svg"; //

import s from "./Tables.module.scss";
import mock from "./mock.js";

import { css } from "@emotion/react";
import { ClockLoader } from "react-spinners";
import BaseAPI from '../../api/apiurl.js';
import Select from "react-select";
import DatePicker from 'react-datepicker';

import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FaCalendar } from 'react-icons/fa';
import '../subpages/datepicker.css';


const Task = function () {


  const [firstTable] = useState(mock.firstTable);
  const [secondTable] = useState(mock.secondTable);
  const [secondTableCurrentPage, setSecondTableCurrentPage] = useState(0); //
  const [tableDropdownOpen, setTableMenuOpen] = useState(false); //
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [staffname, setStaffnam] = useState([]); // staff droupdown
  const [selectedstaff, setSelectedstaff] = useState([]);
  const [projectDropdown, setProjectDropdown] = useState([]); // project droupdown
  const [selectedValueproject, setSelectedValueproject] = useState(null);
  const [selectStatus, setSelectStatus] = useState('');
  const [departmentDropdown, setDepartmentDropdown] = useState([]);
  const [locationDropdown, setLocationDropdown] = useState([]);
  const [selecteddepartment, setSelecteddepartment] = useState(null);
  const [selectedlocation, setSelectedlocation] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const [taskOptions, setTaskOptions] = useState([]);
  const [selectedtask, setselectedTask] = useState(null);
  const [taskKey, setTaskKey] = useState(0);


  const pageSize = 10;
  const secondTablePagesCount = Math.ceil(data.length / pageSize);

  const PaginationComponent = () => {
    const pagesToShow = 5;

    const startPage = Math.max(0, secondTableCurrentPage - Math.floor(pagesToShow / 2));
    const endPage = Math.min(secondTablePagesCount - 1, startPage + pagesToShow - 1);

    return (
      <Pagination className="pagination-with-border">
        <PaginationItem disabled={secondTableCurrentPage <= 0}>
          <PaginationLink
            onClick={(e) => setSecondTablePage(e, secondTableCurrentPage - 1)}
            previous
            href="#top"
          />
        </PaginationItem>
        {[...Array(endPage - startPage + 1)].map((_, i) => (
          <PaginationItem
            key={i}
            active={startPage + i === secondTableCurrentPage}
          >
            <PaginationLink onClick={(e) => setSecondTablePage(e, startPage + i)} href="#top">
              {startPage + i + 1}
            </PaginationLink>
          </PaginationItem>
        ))}
        <PaginationItem disabled={secondTableCurrentPage >= secondTablePagesCount - 1}>
          <PaginationLink
            onClick={(e) => setSecondTablePage(e, secondTableCurrentPage + 1)}
            next
            href="#top"
          />
        </PaginationItem>
      </Pagination>
    );
  };

  const role = localStorage.getItem('role');

  const isRoleTwo = role === '2';

  const setSecondTablePage = (e, index) => {
    e.preventDefault();
    setSecondTableCurrentPage(index);
  }

  const tableMenuOpen = () => {
    setTableMenuOpen(!tableDropdownOpen);
  } //

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleDateChange2 = (date) => {
    setEndDate(date);
  };

  const optionsStatus = [
    { value: '0', label: 'Awaiting' },
    { value: '1', label: 'Planned' },
    { value: '2', label: 'Completed' },
    { value: '3', label: 'In-Audit' },
    { value: '4', label: 'Cancelled' },
  ]

  const handleStatus = (selectedOption) => {
    setSelectStatus(selectedOption.value);
  };

  const fetchData = () => {
    const customerId = localStorage.getItem('customerid');
    const companyId = localStorage.getItem('companyid');

    if (!customerId || !companyId) {
      console.log('Missing customer ID or company ID.');
      return;
    }

    const url = `${BaseAPI}taskview`;
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ customer_id: customerId, company_id: companyId })
    };

    fetch(url, requestOptions)
      .then((response) => response.json())
      .then((actualData) => {
        console.log(actualData);

        setData(actualData.data);
        console.log("response", data);
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const fetchstaff = async () => {
    try {
      const url = `${BaseAPI}servicestaff`;
      const companyId = localStorage.getItem('companyid');
      const customerId = localStorage.getItem('customerid');
      const role = localStorage.getItem('role');
      const Id = localStorage.getItem('id');
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          company_id: companyId,
          customer_id: customerId,
          role_id: role,
          id: Id

        }),
      });

      if (!response.ok) {
        throw new Error('Network response was not ok.');
      }

      const data = await response.json();
      const staffList = data.data.map(item => ({ label: item.username, value: item.id }));

      const defaultSelectedStaff = staffList.length > 0 ? staffList[0] : null;
      setStaffnam(staffList);
      setSelectedstaff(defaultSelectedStaff);

    } catch (error) {
      console.error('Error:', error);
      // Handle the error here if needed
    }
  };

  const fetchProject = async () => {
    try {
      const url = `${BaseAPI}project`;
      const companyId = localStorage.getItem('companyid');
      const customerId = localStorage.getItem('customerid');
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          // You might need to add other headers if required (e.g., authorization headers)
        },
        body: JSON.stringify({
          company_id: companyId,
          customer_id: customerId
        }),

      });

      if (!response.ok) {
        throw new Error('Network response was not ok.');
      }

      const data = await response.json();
      setProjectDropdown(data.data.map(item => ({ label: item.entityname, value: item.id })));
    } catch (error) {
      console.error('Error:', error);
      // Handle the error here if needed
    }
  };

  const fetchDepartment = async () => {
    try {
      const url = `${BaseAPI}projectdepartment`;
      const companyId = localStorage.getItem('companyid');
      const customerId = localStorage.getItem('customerid');
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          // You might need to add other headers if required (e.g., authorization headers)
        },
        body: JSON.stringify({
          company_id: companyId,
          customer_id: customerId
        }),

      });

      if (!response.ok) {
        throw new Error('Network response was not ok.');
      }

      const data = await response.json();
      setDepartmentDropdown(data.data.map(item => ({ label: item.departName, value: item.departid })));
    } catch (error) {
      console.error('Error:', error);
      // Handle the error here if needed
    }
  };

  const fetchLocation = async () => {
    try {
      const url = `${BaseAPI}projectlocation`;
      const companyId = localStorage.getItem('companyid');
      const customerId = localStorage.getItem('customerid');
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          // You might need to add other headers if required (e.g., authorization headers)
        },
        body: JSON.stringify({
          company_id: companyId,
          customer_id: customerId
        }),

      });

      if (!response.ok) {
        throw new Error('Network response was not ok.');
      }

      const data = await response.json();
      setLocationDropdown(data.data.map(item => ({ label: item.AssignDesc, value: item.assignid })));
    } catch (error) {
      console.error('Error:', error);
      // Handle the error here if needed
    }
  };

  const handleProductChange = async (newValue) => {
    setSelectedValueproject(newValue);

    try {
      const projectId = newValue && typeof newValue === 'object' ? newValue.value : null;

      if (projectId) {
       
        setTaskOptions([]);
        setselectedTask(null);
        setTaskKey(prevKey => prevKey + 1);

       
        await fetchTask(projectId);
      } else {
        console.error('Invalid or missing project ID');
      }
    } catch (error) {
      console.error('Error fetching tasks:', error);
      // Handle errors if needed
    }
  };

  const fetchTask = async (projectId) => {

    try {
      const url = `${BaseAPI}audittasks`;
      const companyId = localStorage.getItem('companyid');
      const customerId = localStorage.getItem('customerid');


      const response = await fetch(url, {
        method: 'POST', 
        headers: {
          'Content-Type': 'application/json',
          // You might need to add other headers if required (e.g., authorization headers)
        },
        body: JSON.stringify({
          company_id: companyId,
          customer_id: customerId,
          project_id: projectId // Set the project_id here
        }),
      });

      if (!response.ok) {
        throw new Error('Network response was not ok.');
      }

      const data = await response.json();
      setTaskOptions(data.data.map(item => ({ label: item.tasktitle, value: item.id })));
    } catch (error) {
      console.error('Error:', error);
      // Handle the error here if needed
    }
  };


  const handleSearch = () => {
    const customerId = localStorage.getItem('customerid');
    const companyId = localStorage.getItem('companyid');
  
    if (!customerId || !companyId) {
      console.log('Missing customer ID or company ID.');
      return;
    }
  
    // Check and set empty values to an empty string
    const formattstartdate = selectedDate ? format(selectedDate, 'dd-MM-yyyy') : '';
    const formatenddate = endDate ? format(endDate, 'dd-MM-yyyy') : '';
  
    const projectLabel = selectedValueproject ? selectedValueproject.label || '' : '';
    const departmentLabel = selecteddepartment ? selecteddepartment.label || '' : '';
    const locationLabel = selectedlocation ? selectedlocation.label || '' : '';
    const taskLabel = selectedtask ? selectedtask.label || '' : '';
    const url = `${BaseAPI}taskfilters?company_id=${companyId}&customer_id=${customerId}&project=${projectLabel}&department=${departmentLabel}&task=${taskLabel}&location=${locationLabel}&status=${selectStatus || ''}&startdate=${formattstartdate}&enddate=${formatenddate}`;
  
    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        if (data.data && data.data.length > 0) {
          setData(data.data);
        } else {
          setData([]);
        }
      })
      .catch((error) => {
        console.error('Error fetching data from API:', error);
      });
  };
  
  const handleCancel = () => {
    fetchData();
    setSelectedValueproject(null);
    setSelecteddepartment(null);
    setSelectedlocation(null);
    setSelectStatus('');
    setSelectedDate('');
    setEndDate('');
    setselectedTask(null);

  };

  useEffect(() => {
    const loadingTimeout = setTimeout(() => {
      setIsLoading(false);
      fetchData();
      fetchstaff();
      fetchProject();
      fetchDepartment();
      fetchLocation();
      // fetchTask();
      // console.log("001", data);
    }, 2000);

    return () => clearTimeout(loadingTimeout);
  }, []);

 
  return (
    <div>
      {isLoading ? (
        <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
          <ClockLoader color={"#4e73df"} loading={isLoading} css={spinnerStyle} size={100} />
        </div>
      ) : (
        <div>
          <br/>
          <Row >
            <Col>
              <Row className="mb-4">
                <Col>
                  <Widget>
                    <div style={{ padding: "20px" }}>
                       <div className="headline-2" style={{color : "blue"}}>Task Search Filter
                        <div style={{ float: "right" }}>
                          <button type="button" className="btn btn-primary" onClick={handleSearch}>
                            <FontAwesomeIcon icon={faSearch} style={{ marginRight: '5px' }} />
                            Search
                          </button> &nbsp;
                          <button type="button" className="btn btn-primary" onClick={handleCancel} >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="row" style={{ whiteSpace: 'nowrap' }}>
                      <div className="col-sm-3">

                        <label htmlFor="assetCode" className="col-sm-3 col-form-label label-required ">Project</label>
                        <div style={{ marginLeft: "3px", padding: "10px" }}>
                          <Select
                            // isMulti
                            className="select2-selection"
                            placeholder="Choose..."
                            options={projectDropdown}
                            value={selectedValueproject}
                            onChange={handleProductChange}
                          />
                        </div>
                      </div>
                      <div className="col-sm-3">

                        <label htmlFor="assetCode" className="col-sm-3 col-form-label label-required ">Task</label>
                        <div style={{ marginLeft: "3px", padding: "10px" }}>
                        <Select
                    classNamePrefix="select2-selection"
                    placeholder="Choose..."
                    title="Asset Form"
                    options={taskOptions}
                    value={selectedtask}
                    onChange={setselectedTask}
                    key={taskKey}
                  />
                        </div>
                      </div>
                      {/* <div className="col-sm-3">
                        <label htmlFor="assetCode" className="col-sm-3 col-form-label label-required">Stage</label>
                        <div style={{ marginLeft: "3px", padding: "10px" }}>
                          <Select
                            classNamePrefix="select2-selection"
                            placeholder="Choose..."
                            title="Asset Form"
                          // options={options}
                          // onChange={handleStatus}
                          // isMulti={true} 
                          />
                        </div>
                      </div> */}
                      <div className="col-sm-3">

                        <label htmlFor="assetCode" className="col-sm-3 col-form-label label-required">Department</label>
                        <div className="row-sm-3" style={{ padding: "10px" }}>
                          <Select
                            classNamePrefix="select2-selection"
                            placeholder="Choose..."
                            title="Asset Form"
                            options={departmentDropdown}
                            value={selecteddepartment}
                            onChange={setSelecteddepartment}
                          />
                        </div>
                      </div>
                      <div className="col-sm-3">

                        <label htmlFor="assetCode" className="col-sm-4 col-form-label label-required">Location</label>
                        <div className="row-sm-3" style={{ marginRight: '5px', padding: "10px" }}>
                          <Select
                            classNamePrefix="select2-selection"
                            placeholder="Choose..."
                            title="Asset Form"
                            options={locationDropdown}
                            value={selectedlocation}
                            onChange={setSelectedlocation}
                          />
                        </div>

                      </div>
                      {/* <div className="col-sm-3">

                        <label htmlFor="assetCode" className="col-sm-4 col-form-label label-required">User name [ID] </label>
                        <div className="row-sm-3" style={{ marginRight: '5px', padding: "10px" }}>
                        <Select
                                        classNamePrefix="select2-selection"
                                        placeholder="Choose..."
                                        title="Asset Form"
                                        options={staffname}
                                        value={selectedstaff}
                                        onChange={(selectedOption) => {
                                            setSelectedstaff(selectedOption ? selectedOption : null);
                                        }} 
                                        isDisabled={isRoleTwo}
                                    />
                        </div>

                      </div> */}
                      <div className="col-sm-3">

                        <label htmlFor="assetCode" className="col-sm-4 col-form-label label-required">Status
                        </label>
                        <div style={{ marginRight: '5px', padding: "10px" }}>
                        <Select
  classNamePrefix="select2-selection"
  placeholder="Choose..."
  title="Asset Form"
  options={optionsStatus}
  onChange={handleStatus}
  value={optionsStatus.find(option => option.value === selectStatus) || ''} // Ensure value reflects selectStatus
/>

                        </div>

                      </div>
                      <div className="col-sm-3">
                        <label htmlFor="assetCode" className="col-sm-4 col-form-label label-required">Task Start Date</label>
                        <div className="d-flex justify-content-center align-items-center" style={{padding: "10px" , width: '100%' }}>
                            <DatePicker
                              type="text"
                              selected={selectedDate}
                              onChange={handleDateChange}
                              dateFormat="dd/MM/yyyy"
                              placeholderText="Start a date"
                              className=" form-control custom-datepicker"
                              wrapperClassName="custom-datepicker-wrapper"
                              selectsStart
                              showYearDropdown
                              scrollableYearDropdown
                            />
                        </div>
                      </div>
                      <div className="col-sm-3">
                        <label htmlFor="assetCode" className="col-sm-4 col-form-label label-required">Task End Date</label>
                        <div className="d-flex justify-content-center align-items-center" style={{  padding: "9px" ,  marginLeft: '0px' }} >
                            <DatePicker
                              type="text"
                              className=" form-control custom-datepicker"
                              wrapperClassName="custom-datepicker-wrapper"
                              selected={endDate} // Replace with your state variable for the selected date
                              onChange={handleDateChange2}
                              dateFormat="dd/MM/yyyy"
                              placeholderText="End a date"
                              selectsEnd
                              showYearDropdown
                              scrollableYearDropdown
                            />
                        </div>
                      </div>

                    </div>



                  </Widget>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col>
              <Row className="mb-4">
                <Col>
                  <Widget>
                    <div style={{ padding: "20px" }}>
                       <div className="headline-2" style={{color : "blue"}}>Task Details</div>
                    </div>
                    <div className="widget-table-overflow">
                      <Table className="table-striped table-borderless table-hover" responsive>
                        <thead>
                          <tr style={{ whiteSpace: 'nowrap' }}>
                            <th>priority</th>
                            <th>Project / Stage</th>
                            <th>Task Name</th>
                            <th>Location</th>
                            <th>Department</th>
                            <th>Planned Date</th>
                            <th>End Date </th>
                            <th>Supervisor (Team)</th>
                            <th>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {/* {secondTable
                      .slice(
                        secondTableCurrentPage * pageSize,
                        (secondTableCurrentPage + 1) * pageSize
                      )
                      .map(item => (
                      <tr key={uuidv4()}>
                        <td>
                          <div className="checkbox checkbox-primary">
                            <input
                              id={item.id}
                              className="styled"
                              type="checkbox"
                            />
                            <label for={item.id} />
                          </div>
                        </td>
                        <td>{item.name}</td>
                        <td>{item.email}</td>
                        <td>{item.product}</td>
                        <td>{item.price}</td>
                        <td>{item.date}</td>
                        <td><Badge color={item.color}>{item.status}</Badge></td>
                      </tr>
                    ))} */}
                          {data && data.length > 0 ? (
                            data
                              .slice(secondTableCurrentPage * pageSize, (secondTableCurrentPage + 1) * pageSize)
                              .map((item, index) => (
                                <tr key={index.id}>
                                  <td>{item.priority}</td>
                                  <td>{item.Entityname}</td>
                                  <td>{item.Tasktitle}</td>
                                  <td>{item.AssignDesc}</td>
                                  <td>{item.departName}</td>
                                  <td>{item.Startdate}</td>
                                  <td>{item.Enddate}</td>
                                  <td>{item.Staffestimated}</td>
                                  {/* <td>{item.Status}</td> */}
                                  <td><Badge style={{
                                    backgroundColor:

                                      item.Status === 'Awaiting' ? '#00308F' :
                                        item.Status === 'Planned' ? 'blue' :
                                          item.Status === 'Completed' ? 'Green' :
                                            item.Status === 'In-Audit' ? 'orange' :
                                              item.Status === 'Cancelled' ? 'gray' : 'black',
                                    color: item.Status === '' ? 'black' : 'white',
                                  }}>{item.Status}</Badge>
                                  </td>
                                </tr>
                              ))
                          ) : (
                            <tr>
                              <td colSpan="9" style={{ textAlign: "center", color: "red" }}>
                                No data available
                              </td>
                            </tr>
                          )}

                        </tbody>
                      </Table>
                      <PaginationComponent />
                    </div>
                  </Widget>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      )}
    </div>
  )
}
const spinnerStyle = css`
display: block;
margin: 0 auto;
`;

export default Task;
